var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCollectionIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B6B6B6",
    d: "M18.764 15c.74 0 1.438.297 1.961.833l.278.284.274-.28a2.72 2.72 0 0 1 1.958-.83c.74 0 1.434.292 1.957.829A2.84 2.84 0 0 1 26 17.84c0 .757-.288 1.47-.812 2.005l-3.986 4.57A.283.283 0 0 1 21 24.5a.285.285 0 0 1-.201-.087l-3.985-4.576A2.849 2.849 0 0 1 16 17.834a2.84 2.84 0 0 1 .81-2.005A2.717 2.717 0 0 1 18.764 15zM12 21a1.5 1.5 0 0 1 0 3H3.5a1.5 1.5 0 0 1 0-3H12zm0-6a1.5 1.5 0 0 1 0 3H3.5a1.5 1.5 0 0 1 0-3H12zm12.5-6a1.5 1.5 0 0 1 0 3h-21a1.5 1.5 0 0 1 0-3h21zm0-6a1.5 1.5 0 0 1 0 3h-21a1.5 1.5 0 0 1 0-3h21z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCollectionIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/collection-icon.be2a4a644ca4703d45a3160839825909.svg";